<template>
  <div class="home-item-title">
    {{ title }}
    <p class="sub-title">{{ subTitle }}</p>
  </div>
</template>
<script>
export default {
  props: ["title", "subTitle"],
};
</script>
<style scoped>
.home-item-title {
  width: 100%;
  text-align: center;
  font-size: 25px;
  font-weight: bold;
  color: #dedede;
  position: relative;
}
.home-item-title > .sub-title {
  font-size: 18px;
  font-weight: bold;
  color: #4a7cee;
  width: 100%;
  padding: 0;
  position: absolute;
  top: 12px;
}
</style>


// WEBPACK FOOTER //
// src/components/home/homeItemTitle.vue